import type { OrganisationDataDto } from '@dhl/mdp-api'
import type { OrganisationData } from '~/modules/organisations/model'
import { convertToAddress } from '~/common/components/addresses'
import { convertToContactPerson } from '~/common/model/contact'

export const convertToOrganisationData = (organisationData: OrganisationDataDto): OrganisationData => {
  const { chamberOfCommerce, icoNumber, ...rest } = organisationData

  const address = organisationData.address
    ? convertToAddress(organisationData.address)
    : {
        // Some database ccc orgs have no address stored
        countryCode: 'NL',
        city: '',
        street: '',
        isBusiness: true,
      }

  const contactPerson = convertToContactPerson(organisationData.contactPerson)

  if (icoNumber) {
    return { ...rest, address, contactPerson, icoNumber }
  }

  return { ...rest, address, contactPerson, chamberOfCommerce }
}
